export * from './tab-nav-bar';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/tabs/tab-nav-bar/index.js
// module id = 1033
// module chunks = 3